import { nubankPurchaseApi } from "@b2bportal/nubank-purchase-api";
import { axiosInstance } from "@hopper-b2b/api";
import {
  cartQuoteSelectors,
  getObjectKeysAsObject,
} from "@hopper-b2b/checkout";

import type { FlightMachineContext } from "../../types";

export const services = {
  applyFees: async (context: FlightMachineContext) => {
    const cipherText = cartQuoteSelectors.getPriceQuoteCipherText({ context });
    if (!cipherText) {
      throw new Error("No quote token provided");
    }

    try {
      const res = await nubankPurchaseApi(
        axiosInstance
      ).apiV0PurchaseQuoteFeesApplyPost({
        quoteToken: cipherText,
      });

      return res.data;
    } catch (error) {
      throw new Error("Failed to apply fees", { cause: error });
    }
  },
};

export const ServiceTypes = getObjectKeysAsObject(services);
